import { call, put, takeLatest } from 'redux-saga/effects';
import apiClient from 'helpers/apiClient';
import {
  FETCH_SUMMARY_START,
  fetchSummarySuccess,
  fetchSummaryFailure
} from './DashboardSummary.ducks';

function hasPermissionForSummary() {
  const account = window.Account?.getAccountForActiveCampaign();
  const accountHasFeatureFlag = account?.hasFeatureFlag?.('smart_dashboards') === true;

  const splitEnabled = window.splitHelper?.getTreatment?.('Smart_Dashboard') === 'on';

  return accountHasFeatureFlag && splitEnabled;
}

export function* fetchDashboardSummary(action) {
  try {
    const hasPermission = hasPermissionForSummary();

    if (!hasPermission) {
      yield put(fetchSummaryFailure('Access denied: Summary feature not enabled for this user'));
      return;
    }

    const { dashboardId, activeFilter, activeProfileId, forceRefresh } = action.payload;

    const requestBody = {};

    if (activeFilter && activeFilter.id) {
      requestBody.smartFilterId = activeFilter.id;
    }

    if (activeProfileId) {
      requestBody.profileIds = [activeProfileId];
    }

    if (forceRefresh) {
      requestBody.forceRefresh = true;
    }

    const response = yield call(apiClient, `/api/dashboards/${dashboardId}/summary`, {
      method: 'POST',
      body: JSON.stringify(requestBody)
    });

    const jsonContent = response.json || response.content || response;

    yield put(fetchSummarySuccess(jsonContent));
  } catch (error) {
    console.warn('Dashboard summary fetch failed:', error);
    yield put(fetchSummaryFailure(error.message || 'Failed to fetch summary'));
  }
}

export default function* dashboardSummarySaga() {
  yield takeLatest(FETCH_SUMMARY_START, fetchDashboardSummary);
}
